const DayOfTheWeekPluginSettings: IPluginSettings = {
    name: "Дни недели",
    mnemocode: "discount_condition_type_plugin",
    permission: "DiscountConditionType",
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ID",
            visibility: true,
            width: 80,
        },
        {
            order: 1,
            propertyName: "displayName",
            propertyType: "string",
            displayName: "День недели",
            visibility: true,
            width: 220,
        },
    ],
};

export default DayOfTheWeekPluginSettings;
